import { FC } from 'react';
import { useLocalizedStrings } from '../../../../Localization';
import { stringToColor } from '../../../../Util';
import { useOtherUsersViewing } from '../shared/hooks';
import { getInitials } from '../shared/utils';
import { OtherUsersViewingSectionProps } from '../shared/types';

/**
 * Section showing a facepile of other users currently viewing the same case
 */
export const OtherUsersViewingSection: FC<OtherUsersViewingSectionProps> = ({ caseId, currentUserName }) => {
  const L = useLocalizedStrings();
  const otherUsers = useOtherUsersViewing(caseId, currentUserName);

  return (
    <div className="min-w-0">
      <h3 className="text-sm font-semibold text-gray-500 uppercase mb-2">
        {L.support.other_users_viewing}
      </h3>

      {otherUsers.length === 0 ? (
        <div className="text-sm text-gray-600 break-words">{L.support.no_other_users_viewing}</div>
      ) : (
        <div className="flex items-center gap-2">
          <div className="flex -space-x-2 flex-shrink-0">
            {otherUsers.slice(0, 3).map((user) => {
              const userKey = user.name + '/' + user.browserTab;
              const initials = getInitials(user.name);
              const backgroundColor = stringToColor(userKey, '75%');

              return (
                <div
                  key={userKey}
                  title={`${user.name.split('/')[0]} (${user.browserTab})`}
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full text-white font-medium text-sm ring-2 ring-white"
                  style={{ backgroundColor }}
                >
                  {initials}
                </div>
              );
            })}
          </div>
          <div className="text-sm text-gray-600 break-words">
            {otherUsers.map(u => u.name.split('/')[0]).join(', ')}
          </div>
        </div>
      )}
    </div>
  );
};
